import React from 'react';
import { getContext } from 'common';
import Styled from './styles';

export interface TreeFilterContainerProps extends React.ComponentPropsWithRef<'div'> {
  /** Filter component. Consider using `FilterField`. */
  children: React.ReactNode;
}

/** Component for formatting TreeFilter. Any other props than the `TreeFilterContainer` props will be provided to the root element. */
const TreeFilterContainer = React.forwardRef<HTMLElement, TreeFilterContainerProps>((props: TreeFilterContainerProps, ref) => getContext(({ RTL }) => {
  const { children, ...otherProps } = props;
  return (
    <Styled.TreeFilterContainer ref={ref} RTL={RTL} {...otherProps}>
      {children}
    </Styled.TreeFilterContainer>
  );
}));

TreeFilterContainer.displayName = 'TreeFilterContainer';

export default TreeFilterContainer;
